<template>
  <div class="dialog_wrap">
    <el-dialog title="设置专属客服" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
      <div class="dialog_conwrap">
        <p>你已选择夜之为专属客服；</p>
        <el-form ref="form" :model="form" :inline="true">
          <el-form-item>
            <span class="choosedep"></span>
            <el-button @click="choosedep">选择部门</el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="form.name" placeholder="请输入员工姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search"></el-button>
          </el-form-item>
        </el-form>
        <div class="table_wrap">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label width="50">
              <template scope="scope">
                <el-radio
                  :label="scope.$index"
                  v-model="radio"
                  @change.native="getCurrentRow(scope.$index)"
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="头像">
              <template slot-scope="scope">
                <img :src="scope.row.xxx" alt class="table_img" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="name" label="职位"></el-table-column>
            <el-table-column prop="name" label="部门"></el-table-column>
            <el-table-column prop="name" label="手机"></el-table-column>
          </el-table>
          <div class="pag_wrap">
            <el-pagination background layout="prev, pager, next" :total="50"></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save('form')">确 定</el-button>
      </span>
    </el-dialog>
    <chooseDepDialog
      :visible.sync="choosedepdialog"
      v-if="choosedepdialog"
      @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
import api from "@/api.js";
import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
import { pagination } from "@/util/util.js";
export default {
  name: "settingsConsultDialog",
  props: ["visible"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  components: {
    chooseDepDialog
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {},

      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      choosedepdialog: false
    };
  },
  methods: {
    // 选择部门
    choosedep() {
      this.choosedepdialog = true;
    },
    choosedepsucess(val) {
      // this.formdata.depart_name = val.name;
      // this.formdata.depart_id = val.id;
    },
    // 搜索
    search() {
      this.page.pageindex = 1;
      this.querylist();
    },
    // 查询列表
    querylist() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

